import { LoadingSpinner } from "../ui/IconComponents";

const LoadingVideos: React.FC = () => {
  return (
    <div className="text-center py-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
            <LoadingSpinner size="lg" color="text-blue-600" />
          </div>
          <p className="text-gray-600 mb-2">Loading videos...</p>
          <p className="text-gray-500 text-sm">
            Fetching content from the gallery
          </p>
        </div>
  );
};

export default LoadingVideos;